import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import { AudienceGroupItem } from '@/components';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizModal } = component_tool;

class AudienceGroup extends WizContainer {
  componentName = "AudienceGroup";

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      scope: {}
    };
  }

  // 查看受众
  handleLook = (text) => {
    this.setState({ visible: true, scope: text })
  };

  _render() {
    const { visible, scope } = this.state

    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {},
    });

    const modalProps = {
      title: '查看受众组',
      visible,
      footer: null,
      onCancel: () => {
        this.setState({ visible: false })
      }
    }

    return (
      <React.Fragment>
        <WizReduxTemplate {..._reduxTemplateCofig} />
        <WizModal { ...modalProps }>
          <AudienceGroupItem { ...scope } />
        </WizModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(AudienceGroup);
